export default {
  global: {
    ok: 'De acuerdo',
    accept: 'Aceptar',
    continue: 'Continuar',
    cancel: 'Cancelar',
    loading: 'Cargando...',
  },
  vinculacioPage: {
    header: 'Vincula tu\n idCAT Móvil',
    description:
      'Para empezar a utilizar la aplicación, identifícate con tu idCAT Móvil. Solo lo tendrás que hacer una vez.',
    button: 'Vincula idCAT Móvil',
  },
  userAlreadyExistsPage: {
    header: 'Este idCAT Móvil ya está en uso en otro dispositivo',
    description:
      'idCAT Móvil solo puede estar vinculado a un dispositivo móvil. Si decides vincularlo en este, se desactivará en el dispositivo anterior.',
  },
  successPage: {
    header: 'Autenticación completada con éxito',
    description:
      'El documento identificativo se ha verificado correctamente con idCAT Móvil.\nYa puedes continuar el proceso en la página web del servicio',
  },
  onboardingFinish: {
    header: 'idCAT Móvil vinculado correctamente en este dispositivo',
    description:
      'A partir de ahora ya te puedes identificar con idCAT Móvil para acceder a los trámites de las administraciones públicas catalanas, escaneando el código QR o confirmando la solicitud de acceso.',
    userFields: {
      name: 'Nombre',
      id: 'Documento identificativo',
      phoneNumber: 'Teléfono móvil',
      device: 'Dispositivo vinculado',
    },
  },
  errors: {
    messageProcessing: {
      title: 'Error al procesar el mensaje',
      message:
        'No se pudo procesar el mensaje. Inténtelo de nuevo o póngase en contacto con el servicio de asistencia.',
    },
    invalidRequest: {
      title: 'Solicitud no válida',
      message:
        'Parámetros de solicitud no válidos. Compruébelos y vuelva a intentarlo.',
    },
    authenticationFailed: {
      title: 'Error de autenticación',
      message:
        'Su intento de autenticación no ha tenido éxito. Vuelva a intentarlo o póngase en contacto con el servicio de asistencia.',
    },
    accessDenied: {
      title: 'Acceso denegado',
      message:
        'No tiene permiso para acceder a este recurso. Compruebe sus credenciales y vuelva a intentarlo.',
    },
    connectionError: {
      title: 'Error de conexión',
      message:
        'No se puede conectar al servidor. Compruebe su conexión a Internet y vuelva a intentarlo.',
    },
    aocWalletUserError: {
      title: 'Error de conexión',
      message:
        'Se ha producido un error al intentar recuperar el usuario de la cartera. Vuelva a intentarlo más tarde.',
    },
    generalError: {
      title: 'Error',
      message:
        'Se ha producido un error inesperado. Vuelva a intentarlo o póngase en contacto con el servicio de asistencia.',
    },
  },
};
